export const useRedirectState = () => {
  const isRedirecting = ref(false);
  const redirectTarget = ref<string>('');

  const setRedirecting = (target: string) => {
    isRedirecting.value = true;
    redirectTarget.value = target;
  };

  const clearRedirecting = () => {
    isRedirecting.value = false;
    redirectTarget.value = '';
  };

  return {
    isRedirecting: readonly(isRedirecting),
    redirectTarget: readonly(redirectTarget),
    setRedirecting,
    clearRedirecting
  };
};